import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-nexonBlack">
            <div className="text-center">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/e9a2341e1d0292a8361bdece1a6d21da.png"
                alt="NEXON Lubes"
                className="h-32 w-auto mx-auto mb-8 animate-pulse"
              />
              <div className="w-16 h-16 border-4 border-nexonYellow border-t-transparent rounded-full animate-spin mx-auto"></div>
            </div>
          </div>
        }
      >
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
